// libraries
import React from 'react';
import styled from 'styled-components';

// custom components
import ClientContactForm from './ClientSignUp';
import ProviderContactForm from './ProviderSignUp';

//hooks
import useTerms from 'hooks/useTerms';

// styled components
import { Flex } from 'shared/styledComponents';

// styles
import devices from 'theme/devices';

const ContactFormsWrapper = styled(Flex)`
  margin-top: 145px;
  @media ${devices.mobile} {
    flex-direction: column;
  }
`;

const SignUpWithFooterContactFormsContainer = (): JSX.Element => {
  const { termsOfUse, privacyPolicy } = useTerms({ isPrivacyPolicy: true, isTermsOfUse: true });
  return (
    <ContactFormsWrapper>
      <ClientContactForm termsOfUse={termsOfUse} privacyPolicy={privacyPolicy} />
      <ProviderContactForm termsOfUse={termsOfUse} privacyPolicy={privacyPolicy} />
    </ContactFormsWrapper>
  );
};

export default SignUpWithFooterContactFormsContainer;
